import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CaseType } from '..';

@Injectable({ providedIn: 'root' })
export class CaseTypeService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}`;

  loadCaseTypes(): Observable<{ count: number; result: CaseType[] }> {
    return this.http.get<{ count: number; result: CaseType[] }>(
      `${this.baseUrl}/case-types`
    );
  }
}
